export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/unselected-star-icon.png?bfc161cfdbcd6bd870fcc38a4cf390d9";